import { memo } from 'react'

import {
	Divider,
	HStack,
	Skeleton,
	SkeletonText,
	Stack
} from '@chakra-ui/react'

interface OfferCardSkeletonProps {
	className?: string
}

export const OfferCardSkeleton = memo(
	({ className }: OfferCardSkeletonProps) => {
		return (
			<Stack
				className={className}
				w="300px"
			>
				<Skeleton h="270px" />
				<SkeletonText
					noOfLines={4}
					skeletonHeight={3}
				/>
				<Divider />
				<HStack justifyContent="space-between">
					<HStack>
						<Skeleton
							w="40px"
							h="40px"
						/>
						<Skeleton
							w="40px"
							h="40px"
						/>
					</HStack>
					<Skeleton
						w="80px"
						h="40px"
					/>
				</HStack>
			</Stack>
		)
	}
)

OfferCardSkeleton.displayName = 'OfferCardSkeleton'
